import type { ArtworkLayer, Fill, WearableConfig } from "../types";
import { FillEditor } from "./FillEditor";
import { LayerControls } from "./LayerControls";
import { LayerList } from "./LayerList";
import { Uploader } from "./Uploader";

interface Props {
  config: WearableConfig;
  baseFill: Fill;
  onBaseFill: (f: Fill) => void;
  onFiles: (files: File[]) => void;
  onAddText: () => void;
  layers: ArtworkLayer[];
  selectedLayerId: string | null;
  onSelectLayer: (id: string) => void;
  onToggleVisible: (id: string) => void;
  onReorderLayer: (id: string, dir: "up" | "down") => void;
  onRemoveLayer: (id: string) => void;
  /** Duplicate this layer onto the opposite side (front ↔ back). */
  onDuplicateLayer: (id: string) => void;
  selectedLayer: ArtworkLayer | null;
  onUpdateLayer: (id: string, patch: Partial<ArtworkLayer>) => void;
}

export function RightPanel(p: Props) {
  return (
    <aside className="panel right">
      <h2 className="panel-title">Design</h2>

      <section className="group">
        <h3 className="group-title">Base Color</h3>
        <FillEditor value={p.baseFill} onChange={p.onBaseFill} />
      </section>

      <section className="group">
        <h3 className="group-title">Add Layer</h3>
        <Uploader onFiles={p.onFiles} />
        <button
          type="button"
          className="btn full"
          style={{ marginTop: 8 }}
          onClick={p.onAddText}
        >
          + Add Text Layer
        </button>
      </section>

      <section className="group">
        <h3 className="group-title">Layers</h3>
        <LayerList
          layers={p.layers}
          selectedId={p.selectedLayerId}
          onSelect={p.onSelectLayer}
          onToggleVisible={p.onToggleVisible}
          onReorder={p.onReorderLayer}
          onRemove={p.onRemoveLayer}
        />
      </section>

      <section className="group">
        <h3 className="group-title">Selected Layer</h3>
        {p.selectedLayer ? (
          <LayerControls
            layer={p.selectedLayer}
            config={p.config}
            onChange={(patch) => p.onUpdateLayer(p.selectedLayer!.id, patch)}
            onRemove={() => p.onRemoveLayer(p.selectedLayer!.id)}
            onDuplicate={() => p.onDuplicateLayer(p.selectedLayer!.id)}
          />
        ) : (
          <div className="empty">Select a layer to edit its properties.</div>
        )}
      </section>
    </aside>
  );
}
